import { render, staticRenderFns } from "./productGridComponent.vue?vue&type=template&id=07c1edc0&scoped=true&"
import script from "./productGridComponent.vue?vue&type=script&lang=js&"
export * from "./productGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c1edc0",
  null
  
)

export default component.exports